import styled from '@emotion/styled'
import { Heading } from '@hhgtech/hhg-components/components'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

import { assetImagePath } from 'interfaces/constants'

export const StyledSocialIcon = styled.a`
  display: flex;
  align-items: center;

  .social-icons {
    border-radius: 4px;
    ${MediaQueries.mbDown} {
      width: 24px;
      height: 24px;
    }
    ${MediaQueries.mbUp} {
      width: 32px;
      height: 32px;
    }
  }
`

export const StyledAuthorPage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 64px;

  ${MediaQueries.mbUp} {
    margin-top: 5px;
  }

  ${MediaQueries.mbDown} {
    margin-top: 8px;
    align-items: center;
  }

  .profile-image {
    width: 168px;
    border-radius: 50%;
    object-fit: cover;
  }

  .divider {
    width: 100vw;
    border-width: 4px;
    border-color: ${theme.colors.neutral50};
    margin-left: -16px;
  }

  .list-divider {
    width: 100%;
    border: none;
    border-bottom: 1px solid #e4e8ec;
  }
`
export const StyledInfoContainer = styled.div`
  ${MediaQueries.mbUp} {
    position: relative;
    height: 112px;
    display: flex;
    justify-content: center;
    background: url('${assetImagePath}/expert-background.svg') no-repeat center
      top;
    background-size: contain;
    background-size: cover;
    .avatar-title {
      display: flex;
      position: absolute;
      top: 26px;
    }
    .border-banner {
      margin-top: 76px;
      background: white;
      width: 100%;
      border-radius: 40px 40px 0px 0px;
    }
  }
  ${MediaQueries.mbDown} {
    background: url('${assetImagePath}/expert-background.svg') no-repeat center
      top;
    background-size: contain;
    background-size: cover;
    padding-bottom: 8px;
    height: 78px;
  }
`

export const StyledProfileImage = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;

  ${MediaQueries.mbUp} {
    margin-right: 32px;
    .image-container {
      .profile-image {
        width: 168px;
        height: 168px;
      }
      .badge-avatar {
        position: absolute;
        width: 40px;
        height: 40px;
        bottom: 0;
        right: 0;
      }
    }
  }

  ${MediaQueries.mbDown} {
    position: relative;
    width: 100vw;
    height: 76px;
    .image-container {
      position: absolute;
      top: 26px;

      .profile-image {
        width: 100px;
        height: 100px;
      }

      .badge-avatar {
        position: absolute;
        width: 24px;
        height: 24px;
        bottom: 0;
        right: 0;
      }
    }
  }
`

export const StyledTitleContainer = styled.div`
  ${MediaQueries.mbUp} {
    display: flex;
    max-width: 568px;
    flex-direction: column;
    justify-content: flex-end;
  }
  ${MediaQueries.mbDown} {
    text-align: center;
    background: white;
    width: 100vw;
    border-radius: 20px 20px 0px 0px;
    padding: 66px 16px 26px 16px;
  }
  .position-container {
    display: inline;
    p {
      display: inline;
    }
    ${MediaQueries.mbDown} {
      justify-content: center;
      margin-top: 6px;
    }
    ${MediaQueries.mbUp} {
      margin-top: 8px;
    }
  }
`

export const StyledExpertDescription = styled.div`
  white-space: pre-wrap;
  a {
    color: ${theme.colors.primary600};
  }

  ul {
    padding-left: 1rem;
    margin-block: 1em;
    list-style: inside;
    white-space: normal;
    li {
      position: relative;
      padding-left: 2em;
      margin-bottom: 0.4em;
      list-style-type: none;
      &::before {
        position: absolute;
        top: 0px;
        left: 0px;
        margin-left: 0.5em;
        color: #2d87f3;
        content: '•';
        font-size: 1em;
      }
    }
  }
`

export const StyledAuthorDetail = styled.div`
  width: calc(100% - 190px);
  margin-bottom: 24px;
  line-height: 28px;
  aside.social {
    margin-top: 0.5rem;
  }

  aside.social > *:not(:last-child) {
    margin-right: 0.75rem;
  }

  ${MediaQueries.mbDown} {
    padding-top: 120px;

    width: 100%;
    margin-top: 16px;
    h3 {
      margin-bottom: 8px;
    }
  }
  ${MediaQueries.mbUp} {
    width: 100%;
    margin-top: 80px;
    padding: 0 16px;
    padding-top: 44px;

    h3 {
      margin-bottom: 16px;
    }
    .highlight-wrapper,
    .social-row {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 33px;
    }
    .highlight-item {
      width: calc(33% - 32px);
      margin-right: 32px;
    }
  }
  .see-more {
    display: inline-block;
    color: ${theme.colors.primaryActive};
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
    img {
      width: 16px;
      height: 16px;
      vertical-align: top;
    }
  }

  .expert-description {
    a {
      color: ${theme.colors.primary600};
    }

    ul {
      padding-left: 1rem;
      margin-block: 1em;
      list-style: inside;
      white-space: normal;
      li {
        position: relative;
        padding-left: 2em;
        margin-bottom: 0.4em;
        list-style-type: none;
        &::before {
          position: absolute;
          top: 0px;
          left: 0px;
          margin-left: 0.5em;
          color: #2d87f3;
          content: '•';
          font-size: 1em;
        }
      }
    }
  }
`

export const StyledListItems = styled.div`
  ${MediaQueries.mbDown} {
    padding: 16px 10px;
  }
  ${MediaQueries.mbUp} {
    padding: 16px 0;
  }
`
export const StyledListPapers = styled.div`
  padding: 0;
  transition: height 2s ease-in;
  &[data-is-open='false'] {
    overflow: hidden;
    height: 0;
  }
  &[data-is-open='true'] {
    margin: 16px 0;
  }
  .link-container {
    padding: 16px 16px 0 16px;
    background: ${theme.colors.neutral50};
    overflow-wrap: break-word;
    .paper-link {
      padding-bottom: 16px;
      a {
        color: ${theme.colors.primaryActive};
        cursor: pointer;
        text-decoration: none;
      }
      &[data-is-url-disabled='true'] {
        a {
          color: ${theme.colors.gray600};
          pointer-events: none;
        }
      }
    }
  }
`
export const StyledItem = styled.div`
  display: flex;
  margin-top: 8px;

  .bullet-point {
    width: 24px;
    height: 24px;
  }
`
export const StyledPapersHeading = styled.div`
  .heading-icons {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    vertical-align: top;
  }
`

export const StyledDotSeparator = styled.div`
  display: inline-block;
  width: 3px;
  height: 3px;
  margin-bottom: calc(0.5em - 3px);
  background-color: ${theme.colors.gray400};
  border-radius: 50%;
`

export const StyledReadmorePolicy = styled.a`
  display: flex;
  align-items: center;
  margin-top: 16px;
  cursor: pointer;
  text-decoration: none;
  img {
    width: 18px;
    height: 18px;
  }
`

export const StyledSocicalIconContainer = styled.div`
  display: flex;

  ${MediaQueries.mbDown} {
    justify-content: center;
  }

  ${MediaQueries.mbUp} {
    justify-content: flex-start;
    min-height: 32px;
  }
  margin-top: 16px;

  ${MediaQueries.mbDown} {
    gap: 8px;
  }

  ${MediaQueries.mbUp} {
    gap: 12px;
  }
`

export const StyledBorderHeading = styled(Heading)`
  padding-left: 8px;
  border-left: 5px solid ${theme.colors.primaryBase};
`
